





































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import EchartsHumi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: string;
  mac: string;
  locationName: string;
  StartDate: string;
  EndDate: string;
  scId: string;
  yieldly: string;
  years: string;
  grade: string;
  weight: string;
  Allamount: string;
}
@Component({
  components: { Echarts, EchartsHumi },
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String }) locationName: string;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  mac: string = "";
  yieldly: string = "";
  years: string = "";
  grade: string = "";
  weight: string = "";
  Allamount: string = "";
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  datalist = [];
  yAxisdata: string = "";
  serieslist = [];
  humiserieslist = [];
  humistrtitle: string = "";
  yAxislist = [];
  thdata: Thdata = new Thdata();
  // StartTime: string;
  list = [];
  maclist = [];
  strtitle: string = "";
  title: string = "数据分析";
  datetype: string = "day";
  monthDate: Date = new Date();
  maxtemp: string = "";
  mintemp: string = "";
  maxhumi: string = "";
  minhumi: string = "";
  async getPage() {
    this.maclist = [];
    this.serieslist = [];
    this.strtitle = "";
    this.humistrtitle = "";
    await this.$store
      .dispatch({
        type: "thequipment/getPage",
        data: this.pagerequest,
      })
      .then((res) => {
        res.forEach(async (e, i) => {
          let data = {
            mac: e.mac,
            AddTime: this.pagerequest.AddTime,
          };
          let titlelist = e.mac;
          await this.$store
            .dispatch({
              type: "thdata/getPagedLast",
              data: data,
            })
            .then((thres) => {
              let timelist = [];
              let datalist_temp1 = [];
              let datalist_humi1 = [];
              let serieslist = [];
              let humiserieslist = [];
              for (let entry of thres) {
                timelist.push(
                  this.GetDays(entry.addTime) +
                    " " +
                    this.GetMinutes(entry.addTime)
                );
                datalist_temp1.push(entry.temp1);
                datalist_humi1.push(entry.humi1);
              }
              serieslist.push({
                name: titlelist,
                type: "line",
                data: datalist_temp1,
                areaStyle: {
                  opacity: 0.8,
                  color: {
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(1,191,236)",
                      },
                      {
                        offset: 1,
                        color: "rgba(84, 112, 198)",
                      },
                    ],
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    type: "linear",
                    global: false,
                  },
                },
                markPoint: {
                  data: [
                    { type: "max", name: "最大值" },
                    { type: "min", name: "最小值" },
                  ],
                },
              });
              humiserieslist.push({
                name: titlelist,
                type: "line",
                data: datalist_humi1,
                areaStyle: {
                  opacity: 0.8,
                  color: {
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(1,191,236)",
                      },
                      {
                        offset: 1,
                        color: "rgba(84, 112, 198)",
                      },
                    ],
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    type: "linear",
                    global: false,
                  },
                },
                markPoint: {
                  data: [
                    { type: "max", name: "最大值" },
                    { type: "min", name: "最小值" },
                  ],
                },
              });
              let echartlist = {
                legenddata: JSON.stringify(titlelist),
                xAxisdata: JSON.stringify(timelist),
                seriesdata: JSON.stringify(serieslist),
                humiseriesdata: JSON.stringify(humiserieslist),
              };
              this.list.push(echartlist);
              this.maclist.push(titlelist);
            });
        });
      });
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetDays(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getMonth() + 1) +
      "." +
      this.GetBqMinutes(date.getDate());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();

    if (!value) {
      this.list = [];
      this.$emit("input", value);
    } else {
      this.list = [];
      let year = new Date().getFullYear();
      //月份是从0月开始获取的，所以要+1;
      let month = new Date().getMonth() + 1;
      //日
      let day = new Date().getDate();
      this.pagerequest.AddTime = year + '-' + month + '-' + day;
      this.pagerequest.StartDate = year + '-' + month + '-' + day;
      this.pagerequest.EndDate = year + '-' + month + '-' + day;
      let sdata = this.$store.state.smokeleaf.analyseSmokeleaf;
      this.yieldly = sdata.yieldly;
      this.years = sdata.year;
      this.grade = sdata.grade;
      this.weight = sdata.weight;
      this.Allamount = sdata.allamount;
      this.pagerequest.scId = sdata.sId;
      this.getPage();
    }
  }

  cancel() {
    //this.getPage();
    this.list = [];
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate() {
    if (
      this.pagerequest.StartDate.toString() != "" &&
      this.pagerequest.EndDate.toString() != ""
    ) {
      this.pagerequest.mac = this.mac;
      this.GetPageByDate();
    }
  }
  GetByMonth() {
    if (this.monthDate.toString() != "") {
      var currentY = this.monthDate.getFullYear();
      var currentM = this.monthDate.getMonth() + 1;
      var lastM = new Date(currentY, currentM, 0);
      var lastS = new Date(currentY, currentM - 1);
      this.pagerequest.StartDate = lastS.toString();
      this.pagerequest.EndDate = lastM.toString();
      this.GetPageByDate();
    }
  }
  async GetPageByDate() {
    this.list = [];
    this.maclist.forEach(async (e) => {
      let data = {
        StartDate: this.pagerequest.StartDate,
        EndDate: this.pagerequest.EndDate,
        mac: e,
      };
      let titlelist = e;
      await this.$store
        .dispatch({
          type: "thdata/getPageByDate",
          data: data,
        })
        .then((thres) => {
          let timelist = [];
          let datalist_temp1 = [];
          let datalist_humi1 = [];
          let serieslist = [];
          let humiserieslist = [];
          for (let entry of thres) {
            timelist.push(
              this.GetDays(entry.addTime) + " " + this.GetMinutes(entry.addTime)
            );
            datalist_temp1.push(entry.temp1);
            datalist_humi1.push(entry.humi1);
          }
          serieslist.push({
            name: titlelist,
            type: "line",
            data: datalist_temp1,
            areaStyle: {
              opacity: 0.8,
              color: {
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(1,191,236)",
                  },
                  {
                    offset: 1,
                    color: "rgba(84, 112, 198)",
                  },
                ],
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: "linear",
                global: false,
              },
            },
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
          });
          humiserieslist.push({
            name: titlelist,
            type: "line",
            data: datalist_humi1,
            areaStyle: {
              opacity: 0.8,
              color: {
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(1,191,236)",
                  },
                  {
                    offset: 1,
                    color: "rgba(84, 112, 198)",
                  },
                ],
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: "linear",
                global: false,
              },
            },
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
          });
          let echartlist = {
            legenddata: JSON.stringify(titlelist),
            xAxisdata: JSON.stringify(timelist),
            seriesdata: JSON.stringify(serieslist),
            humiseriesdata: JSON.stringify(humiserieslist),
          };
          this.list.push(echartlist);
        });
    });
  }
}
